module.exports = __webpack_public_path__ + "static/media/right-mountains2.56066443.svg";